var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center mt-10"},[_c('v-progress-circular',{attrs:{"indeterminate":true,"size":"80","width":"4","color":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }